// src/components/common/ConfirmModal.jsx
import React from "react";
import SafeIcon from "../../common/SafeIcon";
import * as FiIcons from "react-icons/fi";

const { FiX, FiAlertTriangle } = FiIcons;

const ConfirmModal = ({
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonClass = "bg-red-500 hover:bg-red-600",
  confirmDisabled = false,
  hideCancel = false,
  hideClose = false,
  onConfirm,
  onCancel,
  onClose,
}) => {
  const handleCancel = onCancel || onClose;
  const cancelDisabled = confirmDisabled;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl max-w-md w-full p-6 shadow-2xl animate-in zoom-in-95 duration-200">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-red-100 rounded-2xl flex items-center justify-center">
              <SafeIcon icon={FiAlertTriangle} className="text-red-600 w-5 h-5" />
            </div>
            <h2 className="text-xl font-bold text-gray-900">{title}</h2>
          </div>

          {!hideClose && (
            <button
              onClick={handleCancel}
              disabled={cancelDisabled}
              className={`p-2 rounded-xl transition-colors ${
                cancelDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100 text-gray-400 hover:text-gray-600"
              }`}
              aria-label="Close"
            >
              <SafeIcon icon={FiX} className="w-5 h-5" />
            </button>
          )}
        </div>

        <div className="py-2">
          <p className="text-gray-600 leading-relaxed">{message}</p>
        </div>

        <div className="flex space-x-3 pt-6">
          {!hideCancel && (
            <button
              onClick={handleCancel}
              disabled={cancelDisabled}
              className={`flex-1 px-4 py-2.5 rounded-2xl font-semibold transition-all ${
                cancelDisabled
                  ? "text-gray-400 bg-gray-50 cursor-not-allowed"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              }`}
            >
              {cancelText}
            </button>
          )}

          <button
            onClick={onConfirm}
            disabled={confirmDisabled}
            className={`${
              hideCancel ? "w-full" : "flex-1"
            } px-4 py-2.5 text-white font-semibold rounded-2xl transition-all shadow-sm ${
              confirmDisabled ? "opacity-60 cursor-not-allowed" : "active:scale-95"
            } ${confirmButtonClass}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;